// Product page collapsible rows and FAQ rows: animate the accordion open/close (height + fade), matching the footer menus.
(() => {
  if (window.accordionAnimateInitialized) return;
  window.accordionAnimateInitialized = true;

  const options = { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' };

  function reset(details, close = false) {
    details.heightAnimation?.cancel();
    details.fadeAnimation?.cancel();
    details.heightAnimation = null;
    details.fadeAnimation = null;
    details.style.overflow = '';

    if (close) {
      details.classList.remove('is-closing');
      details.open = false;
    }
  }

  function toggle(details, open) {
    const summary = details.querySelector('summary');
    const content = summary.nextElementSibling;
    const startHeight = details.offsetHeight;
    const startOpacity = details.heightAnimation && content ? getComputedStyle(content).opacity : open ? 0 : 1;

    reset(details);
    details.open = true;
    details.classList.add('has-toggled');
    details.classList.toggle('is-closing', !open);
    summary.setAttribute('aria-expanded', open);

    const endHeight = open ? details.offsetHeight : summary.offsetHeight;

    if (!content || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      if (!open) reset(details, true);
      return;
    }

    details.style.overflow = 'hidden';
    details.heightAnimation = details.animate({ height: [`${startHeight}px`, `${endHeight}px`] }, options);
    details.fadeAnimation = content.animate({ opacity: [startOpacity, open ? 1 : 0] }, { ...options, fill: 'forwards' });
    details.heightAnimation.onfinish = () => reset(details, !open);
  }

  // Delegated so it keeps working after the section re-renders (variant changes, theme editor).
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.product__accordion--pdp summary, .faqs__summary');
    if (!summary) return;

    event.preventDefault();
    const details = summary.parentElement;
    const isOpen = details.open && !details.classList.contains('is-closing');
    toggle(details, !isOpen);
  });
})();
